import { parsePhoneNumberFromString } from 'libphonenumber-js/max';

export function zipCode(value) {
  if (value && value.length) {
    return /^[0-9]{3} ?[0-9]{2}$/.test(value);
  }
  return false;
}

export function phone(prefix) {
  return value => {
    if (value === null) {
      return true;
    }
    if (value && value.length) {
      const phoneNumber = parsePhoneNumberFromString(prefix + value);
      if (phoneNumber?.isPossible()) {
        return true;
      }
    }
    return false;
  };
}

export function checked(value) {
  return value;
}

/**
 * Check date validity by constructing Date from supplied values and comparing result with those values
 *
 * @param year year
 * @param jsMonth JS Date's month, ranging 0-11
 * @param day day of the month
 */
function isDateValid(year, jsMonth, day) {
  const date = new Date(year, jsMonth, day);
  return (
    date.getFullYear() === Number(year) &&
    date.getMonth() === Number(jsMonth) &&
    date.getDate() === Number(day)
  );
}

export function birthDate(value) {
  if (value && value.length) {
    const dateArray = value.split('.');
    if (dateArray && Array.isArray(dateArray) && dateArray.length === 3) {
      if (
        dateArray[2].trim().length === 4 &&
        dateArray[1].trim().length < 3 &&
        dateArray[0].trim().length < 3
      ) {
        return true;
      }
    }
  }
  return false;
}

export function birthDateRange(value) {
  if (value && value.length) {
    const dateArray = value.split('.');
    if (dateArray && Array.isArray(dateArray) && dateArray.length === 3) {
      const date = new Date(dateArray[2].trim(), dateArray[1].trim() - 1, dateArray[0].trim());
      if (
        dateArray[2].trim().length === 4 &&
        isDateValid(dateArray[2].trim(), dateArray[1].trim() - 1, dateArray[0].trim()) &&
        date > new Date(1920, 0, 1).getTime() &&
        date < new Date().getTime()
      ) {
        return true;
      }
    }
  }
  return false;
}

export function dateRangeRequired(value) {
  return value.length === 2;
}
